const JOB_TITLE_STATUS_OPTIONS = [
   {
      value: 'all',
      label: 'All Jobs',
      id: 'all',
      name: 'All Jobs',
   },
   {
      value: 'active',
      label: 'Active Jobs',
      id: 'active',
      name: 'Active Jobs',
   },
   {
      value: 'inactive',
      label: 'Inactive Jobs',
      id: 'inactive',
      name: 'Inactive Jobs',
   },
];

export default JOB_TITLE_STATUS_OPTIONS;
